module.exports = __webpack_public_path__ + "img/th_14mm_Agg.c959ae52.jpg";